import { AdminMessage } from "@components/admin/admin-helpers"
import { MediaBlock } from "@components/atoms/MediaBlock"
import { YouTubeVideo } from "@components/media/YouTubeVideo"
import { trackEvent } from "@features/tracking/tracking"
import { defineBlock } from "eddev/blocks"
import { ReactNode, useRef } from "react"

export const meta: BlockMeta = {
  title: "Video",
  category: "media",
  description: "An image block",
  icon: "format-image",
  tags: ["#subpage"],
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("content/video", (props) => {
  let content: ReactNode

  const ref = useRef<HTMLDivElement>(null)

  const trackPlay = () => {
    trackEvent("Play Video", {}, ref.current)
  }

  if (props.videoType === "youtube" && props.youtubeUrl) {
    content = (
      <YouTubeVideo
        videoId={props.youtubeUrl}
        autoplay={false}
        onPlaying={() => {
          trackPlay()
        }}
      />
    )
  } else if (props.videoType === "file" && props.video?.mediaItemUrl) {
    const videoProps: { src: string; controls: boolean; poster?: string } = {
      src: props.video.mediaItemUrl,
      controls: true,
    }

    if (props.videoThumb?.mediaItemUrl) {
      videoProps.poster = props.videoThumb.mediaItemUrl
    }

    content = (
      <video
        {...videoProps}
        className="aspect-video"
        onPlay={(e) => {
          trackPlay()
        }}
      />
    )
  }
  const hasContent = !!content
  if (!hasContent && !env.admin) {
    return null
  }

  return (
    <div data-mixpanel-block="Video Embed" ref={ref}>
      <MediaBlock layout={props.layout as any}>
        {hasContent ? content : env.admin && <AdminMessage>No video has been selected</AdminMessage>}
      </MediaBlock>
    </div>
  )
})
